import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-include-first-questionnaire',
  templateUrl: './include-first-questionnaire.component.html',
  styleUrls: ['./include-first-questionnaire.component.scss']
})
export class IncludeFirstQuestionnaireComponent {

  @Input() aba: string = '';
  @Input() disabled: boolean = false;
  @Output() clickEvent = new EventEmitter<string>();

  constructor() { }

  onClick(quest?: string) {
    if (!this.disabled) {
      this.clickEvent.emit(quest !== '' ? quest : '');
    }
  }
}
